<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{titulo}}</ion-title>
  </ion-buttons>
</ion-header>

<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>

  <div class="div-imagem-extendido">
    <img [src]="mda.pessoa.foto | image:' '" class="image-extendido" />
  </div>

  <ion-card class="card-full">
    <div *ngIf="loaded">
      <ion-grid style="margin-top: 25px">
        <ion-row>
          <ion-col size="12" class="remove-border">
            <ion-item>
              <ion-label>
                <div class="title-sub">
                  <h3 class="name">{{mda.pessoa.nome}}</h3>
                </div>

                <div class="title-sub">
                  <p>
                    {{ titulo }} {{ 'desde' | translate }} {{ mda.dadosMDA.created_at | dateFormat:"media" }}
                  </p>
                </div>
              </ion-label>
            </ion-item>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-calendar-day div-icon"></i>
          </ion-note>

          <ion-label class="color-title"> {{'Próximo Encontro' | translate}} </ion-label>
        </div>
      </div>

      <div *ngIf="!mda.dadosMDA.proximoEncontro" class="ion-margin-bottom">
        <ion-row class="btn-custom" (click)="agendarEncontro(mda)" *ngIf="discipulador && userProvider.hasConfig(101)">
          <ion-col size="10" class="d-flex ion-align-items-center">
            <p class="ion-padding-start">{{'Agendar Encontro' | translate}}</p>
          </ion-col>
          <ion-col size="2" class="d-flex ion-align-items-center ion-justify-content-center">
            <ion-icon name="add"></ion-icon>
          </ion-col>
        </ion-row>

        <ion-row class="btn-custom" (click)="agendarEncontro(mda)" *ngIf="!discipulador && userProvider.hasConfig(102)">
          <ion-col size="10" class="d-flex ion-align-items-center">
            <p class="ion-padding-start">{{'Agendar Encontro' | translate}}</p>
          </ion-col>
          <ion-col size="2" class="d-flex ion-align-items-center ion-justify-content-center">
            <ion-icon name="add"></ion-icon>
          </ion-col>
        </ion-row>
      </div>

      <ion-card class="card-top" *ngIf="mda.dadosMDA.proximoEncontro">
        <ion-card-header>
          <ion-row>
            <ion-col size="12" class="remove-border alinhamento-center">
              <i class="fas fa-calendar-day i-edit"></i>

              <p>
                {{'Agendado para' | translate}}
                <span>
                  {{(mda.dadosMDA.proximoEncontro !== null) ? (mda.dadosMDA.proximoEncontro.data |
                  dateFormat:"dataHora") : '---'}}
                </span>
              </p>
            </ion-col>
          </ion-row>
        </ion-card-header>

        <ion-card-content class="subCard">
          <ion-row class="row-top" (click)="openDetails(mda);">
            <ion-col size="11">
              <div>
                <p>{{'Detalhes' | translate}}</p>
              </div>
            </ion-col>

            <ion-col size="1">
              <ion-icon name="arrow-forward-outline"></ion-icon>
            </ion-col>
          </ion-row>
        </ion-card-content>
      </ion-card>

      <ion-grid *ngIf="discipulador">
        <div class="gradient-extendido-div">
          <div class="div-top">
            <ion-note slot="start">
              <i class="fas fa-list div-icon"></i>
            </ion-note>

            <ion-label class="color-title"> {{'Gerenciar' | translate}} </ion-label>
          </div>
        </div>

        <ion-row class="ion-align-items-center ion-padding-start border-bottom" *ngIf="discipulador">
          <ion-col size="10" class="ion-margin-bottom ion-margin-top" (click)="ultimosEncontros(mda)">
            <ion-label style="font-size: 12px"> {{'Últimos Encontros' | translate}} </ion-label>
          </ion-col>
          <ion-col size="2">
            <ion-note>
              <i class="fa-regular fa-chevron-right"></i>
            </ion-note>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center ion-padding-start border-bottom" *ngIf="discipulador">
          <ion-col size="10" class="ion-margin-bottom ion-margin-top" (click)="listaHistoricos(mda)">
            <ion-label style="font-size: 12px"> {{'Lista de Históricos' | translate}} </ion-label>
          </ion-col>
          <ion-col size="2">
            <ion-note>
              <i class="fa-regular fa-chevron-right"></i>
            </ion-note>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div *ngIf="!discipulador">
        <div class="gradient-extendido-div">
          <div class="div-top">
            <i class="fa-solid fa-reply div-icon"></i>

            <ion-label class="color-title"> {{'Últimos Encontros' | translate}} </ion-label>
          </div>
        </div>

        <ion-grid *ngIf="mda.ultimosEncontros.length > 0">
          <ion-row *ngFor="let d of mda.ultimosEncontros; let i=index">
            <ion-col
              size="10"
              (click)="selecionarMda(d);"
              *ngIf="i < 5 || mostrarTodos"
              class="border-bottom ion-margin-start"
            >
              <ion-label class="ultimos-encontro">
                <div>
                  <h3>
                    {{ d.status == 0 ? ('Encontro em Aberto' | translate) : d.status == 1 ? ('Encontro realizado' |
                    translate) : d.status == 2 ? ('Encontro não Realizado' | translate) : d.status == 3 ? ('Encontro
                    Desmarcado' | translate) : ('Não Informado' | translate)}}
                  </h3>
                </div>

                <div class="alinhamento-center">
                  <div style="width: 25px; text-align: center;">
                    <i class="fa-solid fa-calendar-day" slot="start"></i>
                  </div>
                  <p>{{d.data | dateFormat: "mediaHora"}}</p>
                </div>

                <div class="alinhamento-center">
                  <div style="width: 25px; text-align: center;">
                    <i class="fa-solid fa-star" slot="start"></i>
                  </div>
                  <p *ngIf="!d.dataQualidadeDiscipulo">{{'Não Avaliado' | translate}}</p>

                  <p *ngIf="d.dataQualidadeDiscipulo">
                    {{'Avaliado no dia ' | translate}} {{d.dataQualidadeDiscipulo | dateFormat:'ddmmyyyy'}}
                  </p>
                </div>
              </ion-label>

              <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
            </ion-col>

            <ion-col size="1" (click)="selecionarMda(d);" *ngIf="i < 5 || mostrarTodos" class="align-center">
              <i class="fa-regular fa-chevron-right"></i>
            </ion-col>
          </ion-row>
        </ion-grid>

        <div *ngIf="mda.ultimosEncontros.length > 5 && !mostrarTodos" class="list-mini-ultimos">
          <ion-list class="remove-border remove-card pointer encontros">
            <ion-item (click)="mostrarTodos = true" class="mostrar-mais">
              <ion-label>
                <h3 class="item-title">
                  {{'Mostrar mais ' | translate}} {{mda.ultimosEncontros.length - 5}} {{'Encontro(s) ' | translate}}
                </h3>
              </ion-label>

              <ion-note class="item-icon">
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </ion-note>
            </ion-item>
          </ion-list>
        </div>
      </div>
    </div>
  </ion-card>
</ion-content>
